import { render, staticRenderFns } from "./authenticationHistory.vue?vue&type=template&id=710124b3&scoped=true&"
import script from "./authenticationHistory.vue?vue&type=script&lang=js&"
export * from "./authenticationHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710124b3",
  null
  
)

export default component.exports